var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner text-center"},[_c('a-icon',{staticClass:"text-primary spinner__icon",attrs:{"type":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }